import { db, auth } from "./index";
import bcrypt from "bcryptjs";

export const add = async (collection, data) => {
  return await db.collection(collection).add({
    createdAt: Date.now(),
    isDeleted: false,
    ...data,
  });
};

export const update = async (collection, id, data) => {
  return await db
    .collection(collection)
    .doc(id)
    .update({
      ...data,
    });
};

export const getById = async (collection, id) => {
  // alert(id);
  let doc = await db.collection(collection).doc(id).get();
  if (!doc.exists) {
    throw new Error(`Not found!!`);
  } else {
    return { id, ...doc.data() };
  }
};

export const fetch = async (collection) => {
  let docs = [];
  let docsSnapshot = await db.collection(collection).get();
  docsSnapshot.forEach((doc) => docs.push({ id: doc.id, ...doc.data() }));
  return docs;
};

export const populateData = async (collection, arrayOfIds) => {
  let allPromises = arrayOfIds.map((id) => getById(collection, id));
  return await Promise.all(allPromises);
};

export const batchUpdate = async (collection, fieldName, value) => {
  let batch = db.batch(),
    docRef,
    docData;
  let docsSnapshot = await db
    .collection(collection)
    .where(fieldName, "array-contains", value)
    .get();
  docsSnapshot.forEach((doc) => {
    docRef = db.collection(collection).doc(doc.id);
    docData = doc.data();
    batch.update(docRef, {
      [`${fieldName}`]: docData[`${fieldName}`].filter(
        (_value) => _value !== value
      ),
    });
  });
  return await batch.commit();
};

export const updateProfile = async (params) => {
  const user = auth.currentUser;
  return await update("users", user.uid, params);
};

export const fetchSubCategoryFields = async (id) => {
  let docs = [];
  let docsSnapshot = await db
    .collection("subCategoryFields")
    .where("subCategoryId", "==", id)
    .get();

  docsSnapshot.forEach((doc) => docs.push({ id: doc.id, ...doc.data() }));
  return docs;
};
export const fetchSubCategory = async () => {
  let docs = [];
  let docsSnapshot = await db
    .collection("subCategoryFields")
    .get();

  docsSnapshot.forEach((doc) => docs.push({ id: doc.id, ...doc.data() }));
  return docs;
};

export const updatePassword = async (newPassword) => {
  const user = auth.currentUser;
  let password = await bcrypt.hash(newPassword, 10);
  await user.updatePassword(newPassword);
  return await update("users", user.uid, { password: password });
};

export const convertCollectionsSnapshotToMap = (collections) => {
  const transformedCollection = collections.docs.map((doc) => {
    const { title, items } = doc.data();

    return {
      routeName: encodeURI(title.toLowerCase()),
      id: doc.id,
      title,
      items,
    };
  });

  return transformedCollection.reduce((accumulator, collection) => {
    accumulator[collection.title.toLowerCase()] = collection;
    return accumulator;
  }, {});
};

/**method to fetch products in which users has made an offer */
export const fetchBids = async (userId) => {
  let docs = [];
  let docsSnapshot = await db
    .collection("products")
    .where("offerUsers", "array-contains", userId)
    .get();
  docsSnapshot.forEach((doc) => docs.push({ id: doc.id, ...doc.data() }));
  return docs;
};

//method to fetch all categories
export const getCategories = async () => {
  let query = db.collection("categories");
  return await query.get();
}

//method to fetch all subcategories of a category
export const getSubCategories = async (categoryId) => {
  let query = db.collection("subCategories");
  query = query.where("catId", "==", categoryId);
  return query.get();
}


export const fetchcategories = async () => {
  let query = db.collection("categories");
  // console.log("categories firestore: ", await query.get());
  return await query.get();
}

export const fetchSubcategory = async () => {
  let query = db.collection("subCategories");
  return await query.get();
}
// method to fetch featured products

export const getProducts = async () => {

  try {
    // method to fetch featured products
    
    // let query = db.collection("products").doc('MeszeT0gbl7UR1xvbEh7')
    let query = db.collection("products");
    // alert('-------->query')
    // alert(JSON.stringify(query));
    // alert('-------->db')
    // alert(JSON.stringify(db));
    // alert('-------->auth')
    // alert(JSON.stringify(auth));
    console.log("firebase method result for getProducts: ", await query.get());
    return await query.get();
  }
  catch (error) {

    alert(JSON.stringify(error))
  }

}
export const getFeaturedProducts = async (subCategoryId) => {
  // method to fetch featured products
  let query = db.collection("products");
  query = query.where("subCategoryId", "==", subCategoryId);
  return await query.get();
}


// method to fetch filtered products
export const getFilteredProducts = async (filters) => {
  let query = db.collection("products");
  console.log("filters in firestore method: ", filters);
  if (filters.title !== "undefined") {
    console.log("in if title");
    query = query.where("title", "==", filters.title);
  }
  if (filters.categoryId !== "undefined") {
    console.log("in if categoryId");
    query = query.where("catId", "==", filters.categoryId);
  }
  if (filters.subCategoryId !== "undefined") {
    console.log("in if subCategoryid");
    query = query.where("subCategoryId", "==", filters.subCategoryId)
  }
  if (filters.location !== "undefined") {
    console.log("in if location");
    query = query.where("location", "==", filters.location);
  }
  if (filters.distance !== "undefined") {
    console.log("in if distance");
    query = query.where("distance", "==", filters.distance);
  }
  console.log("filtered products from firestore methods: ", await query.get());
  return await query.get();
};

// method to fetch product details
export const getProductInformation = async (productId) => {
  let query = db.collection("products").where('__name__', '==', productId);
  return await query.get();
};